import React, { useEffect, useState } from 'react';
import { Wallet, Loader2, ArrowDownLeft, ArrowUpRight, IndianRupee, ShieldCheck } from 'lucide-react';
import AdminLayout from '../../components/AdminLayout';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authCfg = () => {
  const token = localStorage.getItem('c24_token') || localStorage.getItem('c24_admin_token');
  return { withCredentials: true, headers: token ? { Authorization: `Bearer ${token}` } : {} };
};

const AdminWallet = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/admin/wallet-transactions`, authCfg())
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout title="Wallet Transactions">
      {loading ? (
        <div className="text-center py-16"><Loader2 className="w-6 h-6 animate-spin mx-auto text-neutral-400" /></div>
      ) : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
            <Stat label="Total credited" value={`₹${data.summary.total_credited.toLocaleString('en-IN')}`} icon={ArrowDownLeft} color="#2E7D32" bg="#E8F5E9" testid="admin-wallet-credited" />
            <Stat label="Total debited"  value={`₹${data.summary.total_debited.toLocaleString('en-IN')}`}  icon={ArrowUpRight}  color="#D97706" bg="#FEF3C7" testid="admin-wallet-debited" />
            <Stat label="Balance holding" value={`₹${data.summary.total_balance_holding.toLocaleString('en-IN')}`} icon={IndianRupee} color="#1E88E5" bg="#DBEAFE" testid="admin-wallet-balance" />
            <Stat label="Active wallets" value={data.summary.wallet_count} icon={Wallet} color="#7B1FA2" bg="#F3E5F5" testid="admin-wallet-count" />
          </div>

          <div className="bg-white border border-neutral-200 rounded-2xl overflow-hidden" data-testid="admin-wallet-txn-table">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-neutral-50 border-b border-neutral-200 text-left">
                  <tr><Th>Date</Th><Th>User</Th><Th>Type</Th><Th>Source</Th><Th>Note</Th><Th className="text-right">Amount</Th></tr>
                </thead>
                <tbody>
                  {data.transactions.map((t) => (
                    <tr key={t.id} data-testid={`admin-wallet-txn-${t.id}`} className="border-b border-neutral-100 hover:bg-neutral-50">
                      <td className="px-4 py-3 text-xs text-neutral-500 whitespace-nowrap">{new Date(t.created_at).toLocaleString('en-IN')}</td>
                      <td className="px-4 py-3">
                        <p className="font-semibold text-neutral-900">{t.user_name || '—'}</p>
                        <p className="text-xs text-neutral-500">{t.user_email}</p>
                      </td>
                      <td className="px-4 py-3">
                        <span className={`text-[11px] font-bold px-2 py-0.5 rounded uppercase ${t.type === 'credit' ? 'bg-[#E8F5E9] text-[#2E7D32]' : 'bg-[#FEF3C7] text-[#D97706]'}`}>{t.type}</span>
                      </td>
                      <td className="px-4 py-3 text-neutral-600 text-xs">{t.source}</td>
                      <td className="px-4 py-3 text-neutral-600 text-xs">{t.note}</td>
                      <td className={`px-4 py-3 text-right font-bold ${t.type === 'credit' ? 'text-[#2E7D32]' : 'text-[#D97706]'}`}>
                        {t.type === 'credit' ? '+' : '−'} ₹{t.amount}
                      </td>
                    </tr>
                  ))}
                  {data.transactions.length === 0 && <tr><td colSpan="6" className="text-center text-neutral-500 py-8">No wallet activity yet</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
          <p className="mt-3 text-[11px] text-neutral-500 flex items-center gap-1"><ShieldCheck className="w-3 h-3 text-[#2E7D32]" /> Reading from shared collections: wallets, wallet_transactions.</p>
        </>
      )}
    </AdminLayout>
  );
};

const Stat = ({ label, value, icon: Icon, color, bg, testid }) => (
  <div data-testid={testid} className="bg-white border border-neutral-200 rounded-xl p-4">
    <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: bg }}>
      <Icon className="w-5 h-5" style={{ color }} />
    </div>
    <p className="mt-3 text-xs text-neutral-500 font-medium">{label}</p>
    <p className="font-extrabold text-xl mt-0.5">{value}</p>
  </div>
);
const Th = ({ children, className = '' }) => <th className={`px-4 py-2.5 text-xs font-bold text-neutral-500 uppercase tracking-wider ${className}`}>{children}</th>;

export default AdminWallet;
